import { render, staticRenderFns } from "./GoodsServiceManagementView.vue?vue&type=template&id=4398e978"
import script from "./GoodsServiceManagementView.vue?vue&type=script&lang=js"
export * from "./GoodsServiceManagementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4398e978')) {
      api.createRecord('4398e978', component.options)
    } else {
      api.reload('4398e978', component.options)
    }
    module.hot.accept("./GoodsServiceManagementView.vue?vue&type=template&id=4398e978", function () {
      api.rerender('4398e978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sinvoice_viettel/GoodsServiceManagementView.vue"
export default component.exports